import { UserManagementList } from '@/features/user-management/user-management-list';

const UserManagementListPage = () => {
  return <UserManagementList />;
};

export default UserManagementListPage;
